import React from 'react';
import classNames from 'classnames';
import style from './index.module.scss';
import Half from './half';
import { jsx as _jsx } from "react/jsx-runtime";
const HalfHalf = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: classNames(style.HalfHalf, style.evolved),
    "data-id": "half-half_index_HalfHalf_div",
    children: children
  });
};
export { Half, HalfHalf };